import { BASE_URL } from 'config';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import axios from "axios";
import Swal from "sweetalert2";
import { Typography } from "@mui/material";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: theme.palette.success.main,
    "&:hover": {
      backgroundColor: theme.palette.success.light,
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: theme.palette.success.main,
  },
}));

export default function ShippingPricingTableData(users, handleEditClick, fetchUsers) {
  console.log("🚀 ~ ShippingPricingTableData ~ users:", users);
  const [isActive, setIsActive] = useState(true);

  const handleSwitch = () => {
    setIsActive(!isActive);
  };
  const editFunction = (user) => {
    console.log(user);
  };
  const handleDeletion = async (user) => {
    if (user.type === "administrator") {
      Swal.fire({
        icon: "error",
        title: "غير مسموح!",
        text: "صلاحيات الحذف مقصورة على المشرفين",
        confirmButtonText: "حسنًا",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      });
      return;
    }
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: `سيتم حذف سعر الشحن "${user.price || "غير محدد"}" بشكل دائم!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d32f2f",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "نعم، احذف!",
      cancelButtonText: "إلغاء",
      buttonsStyling: true,
      reverseButtons: true,
      focusCancel: true,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const token = localStorage.getItem("user-token");
          const response = await axios.get(
            `${BASE_URL}/administrator/shipping-rates/delete/${
              user.id || 0
            }`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          Swal.showValidationMessage(
            `فشل الحذف: ${error.response?.data?.message || error.message}`
          );
          return false;
        }
      },
    });
    if (result.isConfirmed) {
      if (result.value?.status) {
        Swal.fire({
          icon: "success",
          title: "تم الحذف!",
          text: "تم حذف سعر الشحن بنجاح",
        });
        fetchUsers();
      } else {
        Swal.fire({
          title: "فشل الحذف!",
          text: result.value?.message || "حدث خطأ غير متوقع",
          icon: "error",
        });
      }
    }
  };
  const handleActivation = async (user, isActive) => {
    if (user.type == "administrator") {
      Swal.fire({
        icon: "error",
        title: "فشل تحديث حالة سعر الشحن",
        text: "ليس لديك صلاحية تعديل حالة سعر الشحن",
      });
      return;
    }
    try {
      const token = localStorage.getItem("user-token");
      const response = await axios.get(
        `${BASE_URL}/administrator/shipping-rates/active/${user.id || 0}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status) {
        Swal.fire({
          icon: "success",
          title: "تم التحديث!",
          text: "تم تغيير حالة سعر الشحن بنجاح",
        });
        fetchUsers();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "فشل التحديث!",
        text: error.response?.data?.message || "حدث خطأ أثناء التحديث",
      });
    }
  };
  const Author = ({ name }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
      </MDBox>
    </MDBox>
  );

  const Status = ({ isActive }) => (
    <MDBox ml={-1}>
      <MDBadge
        badgeContent={isActive ? "مفعل" : "غير مفعل"}
        color={isActive ? "success" : "dark"}
        variant="gradient"
        sx="larg"
      />
    </MDBox>
  );

  return {
    columns: [
      { Header: "اسم شركة الشحن", accessor: "author", align: "left" },
      { Header: "المنطقة المنشأ", accessor: "origin_region_id", align: "center" },
      { Header: "حي المنشاء", accessor: "origin_place", align: "center" },
      { Header: "المنطقة الوجهة", accessor: "destination_region_id", align: "center" },
      { Header: "حي الوجهة", accessor: "destination_place", align: "center" },
      { Header: "السعر", accessor: "price", align: "center" },
      { Header: "الحالة", accessor: "status", align: "center" },
      { Header: "الإجراءات", accessor: "action", align: "center" },
    ],
    rows: users.map((user) => ({
      author: <Author name={user.shipping_method?.name || "--"} />,
      origin_region_id: (
        <MDTypography display="block" variant="button" fontWeight="medium">
          {user.origin_region?.name || "--"}
        </MDTypography>
      ),
      origin_place: (
        <MDTypography display="block" variant="button" fontWeight="medium">
          {user.origin_region.name || "--"}
        </MDTypography>
      ),

      destination_region_id: (
        <MDTypography display="block" variant="button" fontWeight="medium">
          {user.destination_region?.name || "--"}
        </MDTypography>
      ),
      destination_place: (
        <MDTypography display="block" variant="button" fontWeight="medium">
          {user.destination_region?.name || "--"}
        </MDTypography>
      ),
      price: (
        <MDTypography display="block" variant="button" fontWeight="medium">
          {user.price || "--"}
        </MDTypography>
      ),
      status: <Status isActive={Boolean(user.is_active)} />,
      action: (
        <MDBox
          display="flex"
          alignItems="center"
          gap={1}
          p={1}
          borderRadius="lg"
          bgcolor="background.paper"
          boxShadow={1}
        >
          <CustomSwitch
            checked={Boolean(user.is_active)}
            onChange={(e) => handleActivation(user, e.target.checked)}
            color="default"
          />
          <IconButton
            aria-label="edit"
            sx={{
              color: "info.main",
              "&:hover": {
                transform: "scale(1.1)",
                transition: "transform 0.2s",
              },
            }}
            onClick={() => handleEditClick(user)}
          >
            <EditIcon fontSize="medium" />
          </IconButton>
          <IconButton
            aria-label="delete"
            sx={{
              color: "error.main",
              "&:hover": {
                transform: "scale(1.1)",
                transition: "transform 0.2s",
              },
            }}
            onClick={() => handleDeletion(user)}
          >
            <DeleteIcon fontSize="medium" />
          </IconButton>
        </MDBox>
      ),
    })),
  };
}
